import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeNoResultsComponentClass as cn } from '../filter-options.helper';
import { Icon } from '@doxyme/ui';
import './no-results.scss';
export const NoResults = () => {
    return <div className={cn('wrapper')}>
    <Icon className={cn('image')} name='search-result'/>
    <div className={cn('title')}>
      <FormattedMessage id="account.analytics.filter.no-results.title"/>
    </div>
    <div className={cn('message')}>
      <FormattedMessage id="account.analytics.filter.no-results.message"/>
    </div>
  </div>;
};
